module.exports = __webpack_public_path__ + "static/datbim-plugin-archicad-1-730d687279b1238c183c9bae18a65431.png";